/* eslint-disable @next/next/no-img-element */
import React from 'react';
import {
  Container,
  Typography,
  Link,
  Box,
  Hidden,
  ButtonBase,
} from '@material-ui/core';
import Image from 'next/image';
import NextLink from 'next/link';
import useTranslation from 'hooks/useTranslation';
import { AiOutlineInstagram as AiOutlineInstagramIcon } from 'react-icons/ai';

import Logo from 'assets/logo/PrincipalPositivaPurple.svg';
import theme from 'styles/theme';
import useStyles from './styles';
import SelectLanguageMenu from 'components/SelectLanguageMenu';
import parse from 'html-react-parser';
import { useRouter } from 'next/router';

const Footer: React.FC = () => {
  const classes = useStyles();
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <Box className={classes.box}>
      <Hidden smDown>
        <Box className={classes.boxFooter}>
          <Container maxWidth="md">
            <Box className={classes.footerTop}>
              <div className={classes.footerLogo}>
                <Image
                  src={Logo}
                  className={classes.logo}
                  alt="Logo Instasorteio"
                />
              </div>
              <Typography variant="body2">
                <NextLink href="/">{t('drawLots')}</NextLink>
                <NextLink href="/como-funciona">{t('howItWorks')}</NextLink>
                <Link href="mailto:contato@instasorteio.com" target="_blank">
                  {t('contactUs')}
                </Link>
              </Typography>

              <div>
                <ButtonBase
                  component="a"
                  href="https://www.instagram.com/instasorteioo/"
                  target="_blank"
                >
                  <AiOutlineInstagramIcon />
                </ButtonBase>
              </div>
            </Box>
          </Container>
        </Box>
      </Hidden>

      <Box className={classes.boxCopy}>
        <Container maxWidth="md">
          <Hidden smDown>
            <Box className={classes.copyContainer}>
              <Box className={classes.boxItem}>
                <Typography className={classes.copyright} variant="subtitle2">
                  {parse(t('copyrights'))}
                </Typography>
              </Box>
              <Box className={classes.boxItem}>
                <NextLink href="/termos-de-uso">{t('termsOfUse')}</NextLink>
                <NextLink href="/politica-de-privacidade">
                  {t('privacyPolicy')}
                </NextLink>
              </Box>
              <Box
                className={classes.boxItem}
                style={{ fontSize: 12, color: theme.palette.grey[300] }}
              >
                {t('version')}
              </Box>
              <Box className={classes.boxItem}>
                <SelectLanguageMenu />
              </Box>
            </Box>
          </Hidden>

          <Hidden mdUp>
            <Box className={classes.copyContainerMobile}>
              <Box className={classes.boxItem}>
                <SelectLanguageMenu />
              </Box>
              <Box className={classes.boxItem}>
                <Typography className={classes.copyright} variant="subtitle2">
                  {t('copyright')}
                </Typography>
              </Box>
            </Box>
          </Hidden>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
